import { useI18n } from '../../../../../i18n';
import {
  fetchTiposContrato,
  crearTipoContrato,
  actualizarTipoContrato,
  eliminarTipoContrato,
} from '../../../../shared/services/api';
import { AdminCatalogoSimple } from './AdminCatalogoSimple';

export function AdminTiposContrato() {
  const { t } = useI18n();
  const labels = t.structure.admin.tiposContrato;
  return (
    <AdminCatalogoSimple
      labels={labels}
      api={{
        list: () => fetchTiposContrato(true),
        create: crearTipoContrato,
        update: actualizarTipoContrato,
        remove: eliminarTipoContrato,
      }}
    />
  );
}
